@if(!SelectedInventory){
<div class="inventory-list-view">
  <div class="inventory-list-intro"><strong>Inventory references</strong><span>Open a reference to view shipping, costs, documents, and tracking.</span></div>
  <rms-table (onInventoryUpdated)="refreshInventory($event)" [HeaderButtons]="Buttons" [parentContext]="this" [data]="InventoryList" [layoutType]="'Inventory'" tableId="inventory-management-main" [customizable]="true" [columns]="InventoryColumns" startSort="InventoryID" startSortDirection="desc"></rms-table>
</div>
}
@if(SelectedInventory){
<app-inventory-data (onInventoryUpdated)="refreshInventory($event)" (onReturnToList)="SelectedInventory = null" [InventoryItem]="SelectedInventory"></app-inventory-data>
}
